module.exports = __webpack_public_path__ + "img/wa.9b819965.png";